import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import Connect from './Connect';
import GettingStarted from './GettingStarted';
import WebConnector from './WebConnector';

interface IQBDSetup {
  onConnected: () => void;
}

const QuickbookDesktopSetup = ({ onConnected }: IQBDSetup) => {
  const { t } = useTranslation(['integrations']);
  return (
    <Box>
      <Tabs variant="soft-rounded" colorScheme="green">
        <TabList background="gray.200" borderRadius="0 20px 20px 0" justifyContent="space-between" maxWidth="500px">
          <Tab borderRadius="0 20px 20px 0" flexGrow={1}>
            {t('integrations:gettingStarted')}
          </Tab>
          <Tab borderRadius="0 20px 20px 0" flexGrow={1}>
            {t('integrations:webConnector')}
          </Tab>
          <Tab borderRadius="0 20px 20px 0" flexGrow={1}>
            {t('integrations:connect')}
          </Tab>
        </TabList>
        <TabPanels padding="5px 0 0 0">
          <TabPanel>
            <GettingStarted />
          </TabPanel>
          <TabPanel>
            <WebConnector />
          </TabPanel>
          <TabPanel>
            <Connect onConnect={onConnected} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default QuickbookDesktopSetup;
